module.exports = __webpack_public_path__ + "img/cpdt-ka-color-med.0398a50b.png";